import { get, patch, post } from '../../utils/http';

export const fetchClientBranchCostCenters = ({ accountId, clientId, clientBranchId }) =>
  get(`/accounts/${accountId}/clients/${clientId}/branches/${clientBranchId}/cost-centers`);

export const addClientBranchCostCenters = ({ accountId, clientId, clientBranchId, name, identifier }) =>
  post(`/accounts/${accountId}/clients/${clientId}/branches/${clientBranchId}/cost-centers`, { name, identifier });

export const updateClientBranchCostCenters = ({
  accountId,
  clientId,
  clientBranchId,
  costCenterId,
  name,
  identifier
}) =>
  patch(`/accounts/${accountId}/clients/${clientId}/branches/${clientBranchId}/cost-centers/${costCenterId}`, {
    name,
    identifier
  });
